import { FC, ImgHTMLAttributes, useEffect, useState } from "react";
import { Image } from "@onmo/ui";
import {
  IAvatarSize,
  DefaultProfileSrcSet,
  AvatarSizeMapping,
  FireIconSizeMapping,
} from "../../../constants/user";
import { useStyles } from "./Avatar.style";

interface IAvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
  url?: string;
  size?: IAvatarSize;
  status?: "online" | "offline" | "away";
  icon?: {
    src1x: string;
    src2x?: string;
    src3x?: string;
  };
  actionIcon?: () => void;
  alt?: string;
}

const Avatar: FC<IAvatarProps> = (props) => {
  const {
    id,
    url,
    size = "s",
    status,
    icon,
    onLoad,
    actionIcon,
    alt,
    ...otherProps
  } = props;
  const classes = useStyles();
  const [srcSet, setSrcSet] = useState<string | undefined>(url);

  const avatarSize = AvatarSizeMapping[size];
  const fireIconSize = FireIconSizeMapping[size];

  useEffect(() => {
    if (url) {
      setSrcSet(url);
    }
  }, [url]);

  return (
    <div className={classes.root}>
      <Image
        id={id}
        className={classes.avatar}
        srcSet={srcSet || url || DefaultProfileSrcSet}
        src={srcSet || url || DefaultProfileSrcSet}
        width={avatarSize}
        radius={"50%"}
        height={avatarSize}
        onLoad={onLoad}
        onError={() => setSrcSet(DefaultProfileSrcSet)}
        alt={alt}
        {...otherProps}
      />
      {icon && (
        <Image
          src={icon.src1x}
          src2x={icon.src2x}
          src3x={icon.src3x}
          className={classes.fireIcon}
          width={fireIconSize}
          height={fireIconSize}
          onClick={actionIcon}
          alt={alt}
        />
      )}
    </div>
  );
};

export default Avatar;
